import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import ConfModal from "@/components/ConfModal.vue";
import { Modal } from "flowbite-vue";
import { ref, onMounted } from 'vue';
import { initFlowbite } from "flowbite";
export default /*#__PURE__*/ _defineComponent({
    __name: 'taccuinoLock',
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var indexgl = ref(0);
        var showConfirm = ref(false);
        var resolvePromise;
        onMounted(function () {
            initFlowbite();
        });
        function openModal(message, index) {
            indexgl.value = index;
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function close() {
            showConfirm.value = false;
            if (!resolvePromise)
                return;
            resolvePromise(true);
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            var _component_ConfModalHead = _resolveComponent("ConfModalHead");
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "2xl",
                    onClose: _cache[1] || (_cache[1] = function ($event) { return (close()); })
                }, {
                    header: _withCtx(function () { return [
                        _createVNode(_component_ConfModalHead)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createVNode(ConfModal, {
                            table: 'tbl_taccuinos',
                            idtype: 'id_taccuino',
                            "id-conf": 'id_livello_confidenzialita',
                            index: indexgl.value,
                            onCloseModal: _cache[0] || (_cache[0] = function ($event) { return (close()); })
                        }, null, 8, ["index"])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
